const localHost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/.test(window.location.hostname);

export function canRegisterServiceWorker() {
  return 'serviceWorker' in navigator && (window.isSecureContext || localHost);
}

export function register(config = {}) {
  if (!canRegisterServiceWorker()) return;
  // eslint-disable-next-line no-undef
  const buildHash = typeof __webpack_hash__ !== 'undefined' ? __webpack_hash__ : '';
  const workerUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js${buildHash ? `?v=${buildHash}` : ''}`;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(workerUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state !== 'installed') return;
            if (navigator.serviceWorker.controller) config.onUpdate?.(registration);
            else config.onSuccess?.(registration);
          };
        };
      })
      .catch((err) => console.warn('Service worker registration failed:', err));
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return Promise.resolve(false);
  return navigator.serviceWorker.getRegistration().then((registration) => registration?.unregister() || false);
}
